import { __extends } from 'tslib';
import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkToolbarTypes, UitkToolbarTitleTags, UitkToolbarNavigationTypeIcons } from './types.esm.js';
import styles from './uitk-toolbar.css';
import { UitkToolbarContainer } from './uitk-toolbar-container.esm.js';
import { UitkToolbarButton } from './uitk-toolbar-button.esm.js';

var getClassNameList = classNames.bind(styles);
// To be cleaned up
var ToolbarHeaderType;
(function (ToolbarHeaderType) {
    ToolbarHeaderType["OVERLAY"] = "Overlay";
})(ToolbarHeaderType || (ToolbarHeaderType = {}));
var UitkToolbarExpandedState;
(function (UitkToolbarExpandedState) {
    UitkToolbarExpandedState["EXPANDED"] = "expanded";
    UitkToolbarExpandedState["COLLAPSED"] = "collapsed";
})(UitkToolbarExpandedState || (UitkToolbarExpandedState = {}));
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            elevatedToolbar: false
        };
        _this.isElevatedToolbar = false;
        _this.handleScroll = throttle(100, _this.handleScroll.bind(_this));
        return _this;
    }
    Toolbar.prototype.componentDidUpdate = function () {
        var contentDomRef = this.props.contentDomRef;
        var domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.addEventListener === 'function') {
            domRef.current.addEventListener('scroll', this.handleScroll);
        }
    };
    Toolbar.prototype.componentWillUnmount = function () {
        var contentDomRef = this.props.contentDomRef;
        var domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.removeEventListener === 'function') {
            domRef.current.removeEventListener('scroll', this.handleScroll);
        }
    };
    Toolbar.prototype.handleScroll = function (event) {
        if (event.target.scrollTop > 0) {
            if (!this.isElevatedToolbar) {
                this.toggleElevatedState(true);
            }
        }
        else {
            this.toggleElevatedState(false);
        }
    };
    Toolbar.prototype.toggleElevatedState = function (isElevated) {
        var _this = this;
        this.setState({
            elevatedToolbar: isElevated
        }, function () {
            _this.isElevatedToolbar = isElevated;
        });
    };
    Toolbar.prototype.render = function () {
        var _a = this.props, id = _a.id, className = _a.className, toolbarType = _a.toolbarType, children = _a.children, childClassName = _a.childClassName, navigationContent = _a.navigationContent, toolbarActionContent = _a.toolbarActionContent, toolbarTitle = _a.toolbarTitle, toolbarTitleTag = _a.toolbarTitleTag, toolbarSubtitle = _a.toolbarSubtitle;
        var elevatedToolbar = this.state.elevatedToolbar;
        var containerClassNames = getClassNameList(className, toolbarType && UitkToolbarTypes.get(toolbarType) === 'transparent' && 'uitk-toolbar-transparent', {
            elevated: elevatedToolbar,
            'has-placeholder': children
        });
        var Tag = ((toolbarTitleTag && UitkToolbarTitleTags.get(toolbarTitleTag)) ||
            UitkToolbarTitleTags.get('h2'));
        var toolbarTitleContent = toolbarTitle ? (React.createElement(Tag, { className: getClassNameList("".concat(Toolbar.baseClassName, "-title-content")) }, toolbarTitle)) : null;
        var toolbarSubtitleClassname = getClassNameList("".concat(Toolbar.baseClassName, "-subtitle-content"));
        var toolbarSubtitleContent = toolbarSubtitle &&
            (typeof toolbarSubtitle === 'string' ? (React.createElement("p", { className: toolbarSubtitleClassname }, toolbarSubtitle)) : (React.cloneElement(toolbarSubtitle, { className: toolbarSubtitleClassname })));
        var _b = navigationContent || {}, navType = _b.navType, navIconLabel = _b.navIconLabel, navButtonLabel = _b.navButtonLabel, onClick = _b.onClick, onClickAnalytics = _b.onClickAnalytics, navButtonRef = _b.navButtonRef, navButtonId = _b.navButtonId;
        var iconType = ((navType && UitkToolbarNavigationTypeIcons.get(navType)) ||
            UitkToolbarNavigationTypeIcons.get('close'));
        var expandedState;
        if (navType === 'expand_down')
            expandedState = UitkToolbarExpandedState.EXPANDED;
        if (navType === 'expand_up')
            expandedState = UitkToolbarExpandedState.COLLAPSED;
        return (React.createElement(UitkToolbarContainer, { id: id, className: containerClassNames },
            navigationContent && onClick && (React.createElement(UitkToolbarButton, { onClick: onClick, onClickAnalytics: onClickAnalytics, buttonId: navButtonId, buttonRef: navButtonRef, expandedState: expandedState !== null && expandedState !== void 0 ? expandedState : undefined, containerId: expandedState ? id : undefined },
                React.createElement(UitkIcon, { id: "".concat(navButtonId, "-").concat(iconType, "-toolbar"), name: iconType, size: UitkIconSize.MEDIUM, title: navIconLabel }),
                navButtonLabel)),
            React.createElement(UitkLayoutFlexItem, { grow: 1, className: getClassNameList('truncate') },
                React.createElement("section", null,
                    toolbarTitleContent,
                    toolbarSubtitle && toolbarSubtitleContent)),
            toolbarActionContent,
            children && (React.createElement(UitkLayoutFlexItem, { className: getClassNameList(childClassName), minWidth: "full_width" },
                React.createElement("section", null, children)))));
    };
    Toolbar.displayName = 'UitkToolbar';
    Toolbar.baseClassName = 'uitk-toolbar';
    return Toolbar;
}(React.Component));

export { Toolbar, ToolbarHeaderType, UitkToolbarExpandedState };
